import Link from "next/link";

export const DeployButton = () => (
  <Link
    href={`https://www.bizfynda.com/contact`}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-2 ml-2 bg-black text-white text-sm px-3 py-1.5 rounded-md hover:bg-zinc-900 dark:bg-white dark:text-black dark:hover:bg-zinc-100"
  >
    Contact us
  </Link>
);
